import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ProjectAPIs from '../../../../../../MasonyFixingsAPIs/ProjectAPIs/ProjectAPIs';
import { Card, Form} from 'react-bootstrap';
import DropDown from '../../../../../DropDown/DropDown';
import { MdCancel, MdDelete, MdEdit } from 'react-icons/md';
import { FaSave } from 'react-icons/fa';
import { AiFillEdit } from 'react-icons/ai';
import {format} from 'date-fns';
import { useToast } from '../../../../../../Contexts/ToastContext';
import ApiResponseHandler from '../../../../../../MasonyFixingsAPIs/ApiResponseHandler';

export default function ViewAnchorTraining({anchorTraining, getAnchorTraining}){

    const { addToast } = useToast();
    const params = useParams();
    const navigate = useNavigate();

    const [editing, setEditing] = useState(false);
    const [sending, setSending] = useState(false);
    const [userID, setUserID] = useState(parseInt(anchorTraining.user.id));
    const [date, setDate] = useState(format(new Date(anchorTraining.date), 'yyyy-MM-dd'));
    const [note, setNote] = useState(anchorTraining.note);


    const editAnchorTraining = () => {
        setSending(true);
        const putJSON = {
            user_id: userID,
            date: date,
            note: note
        }
        ProjectAPIs.PutProjectAnchorTraining(params.ProjectID, anchorTraining.id, putJSON)
        .then((response) => {
            if(response.status === 200){
                getAnchorTraining(params.ProjectID);
                setEditing(false);
                setSending(false);
                addToast({ message: "Anchor Training updated successfully!", variant: "success", autoHide: true });
            }
        })
        .catch((err) => {
            console.log(err)
            setSending(false);
            console.log('here')
            ApiResponseHandler(err.response, navigate);
        })
    }

    const deleteAnchorTraining = () => {

        setSending(true);
        ProjectAPIs.DeleteProjectAnchorTraining(params.ProjectID, anchorTraining.id)
        .then((response) => {
            if(response.status === 200){
                getAnchorTraining(params.ProjectID);
                setEditing(false);
                setSending(false);
                addToast({ message: "Anchor Training deleted successfully!", variant: "success", autoHide: true });
            }
        })
        .catch((err) => {
            console.log(err)
            setSending(false);
            if(err.response.status === 401){
                if(err.response.data.logout){
                    navigate('/login');
                }
                else{
                    window.alert(err.response.data.message)
                }
            }
        })
    }

    const handleCancel = () => {
        setUserID(anchorTraining.user.id);
        setDate(anchorTraining.date);
        setNote(anchorTraining.note);
        setEditing(false);
    }

    const handleDelete = () => {
        if(window.confirm('Are you sure you wish to delete this anchor training?')){
            deleteAnchorTraining();
        }
    }


   
    
    return(
        
            <Card key={anchorTraining.id} className="view-contractor-employee-container mb-2">
                <Card.Body>
                    <div>
                        
                        <div className="project-header-actions">
                            {editing ? (
                                <>
                                    <button size="sm" disabled={sending} className="save-btn" onClick={() => editAnchorTraining()}>Save</button>
                                    <button size="sm" disabled={sending} className="cancel-btn" onClick={() => setEditing(false)} >Cancel</button>
                                </>
                            ) : (
                                <>
                                    <button size="sm" disabled={sending} className="edit-btn" onClick={() => setEditing(true)}><MdEdit /> Edit</button>
                                    <button size="sm" disabled={sending} className="projects-delete-btn" onClick={() => handleDelete()} ><MdDelete /></button>
                                </>
                            )}
                        </div>
                    </div>
                    <div>
                            {editing ? 
                            <DropDown.Users
                                    value={userID}
                                    onChange={(e) => setUserID(e.target.value)}
                                    required
                                    disabled={sending}
                                    className='editable-field m-1'
                                />
                            :
                            <strong>{anchorTraining.user.first_name  + ' ' +anchorTraining.user.last_name}</strong>}

                            {editing ? 
                            <Form.Control
                                type="date"
                                required
                                disabled={sending}
                                value={date}
                                onChange={(e) => setDate(e.target.value)}
                                className="editable-field m-1"
                            />
                            :
                        <div><strong>Date Completed:</strong> {new Date(anchorTraining.date).toLocaleDateString()}</div>
                            }
                            {editing ? 
                            <Form.Control
                                required
                                disabled={sending}
                                as='textarea'
                                rows={3}
                                placeholder='Leave a note...'
                                value={note}
                                onChange={(e) => setNote(e.target.value)}
                                className="editable-field m-1"
                            />
                            :
                            <div><strong>Note:</strong> {anchorTraining.note}</div>
                            }
                    </div>
                </Card.Body>
            </Card>
    )
    


}